const states = [
  'Alabama',
  'Alaska',
  'American Samoa',
  'Arizona',
  'Arkansas',
  'California',
  'Colorado',
  'Connecticut',
  'Delaware',
  'District Of Columbia',
  'Federated States Of Micronesia',
  'Florida',
  'Georgia',
  'Guam',
  'Hawaii',
  'Idaho',
  'Illinois',
  'Indiana',
  'Iowa',
  'Kansas',
  'Kentucky',
  'Louisiana',
  'Maine',
  'Marshall Islands',
  'Maryland',
  'Massachusetts',
  'Michigan',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Montana',
  'Nebraska',
  'Nevada',
  'New Hampshire',
  'New Jersey',
  'New Mexico',
  'New York',
  'North Carolina',
  'North Dakota',
  'Northern Mariana Islands',
  'Ohio',
  'Oklahoma',
  'Oregon',
  'Palau',
  'Pennsylvania',
  'Puerto Rico',
  'Rhode Island',
  'South Carolina',
  'South Dakota',
  'Tennessee',
  'Texas',
  'Utah',
  'Vermont',
  'Virgin Islands',
  'Virginia',
  'Washington',
  'West Virginia',
  'Wisconsin',
  'Wyoming'
];

const colHeaders = [
  'ID',
  'Name *',
  'Abbreviation',
  'Address Line 1',
  'Address Line 2',
  'City',
  'State',
  'Zip Code',
  'Phone Number One',
  'Phone Number One Name',
  'Phone Number Two',
  'Phone Number Two Name',
  'Lesson Requests Offered',
  'Notes'
];

const columns = [
  {
    data: 'id',
    type: 'text',
    readOnly: true
  },
  {
    data: 'name',
    type: 'text'
  },
  {
    data: 'abbreviation',
    type: 'text'
  },
  {
    data: 'address1',
    type: 'text'
  },
  {
    data: 'address2',
    type: 'text'
  },
  {
    data: 'city',
    type: 'text'
  },
  {
    data: 'state',
    type: 'autocomplete',
    source: states,
    strict: false
  },
  {
    data: 'zipcode',
    type: 'text'
  },
  {
    data: 'phone_number_one',
    type: 'text'
  },
  {
    data: 'phone_number_one_name',
    type: 'text'
  },
  {
    data: 'phone_number_two',
    type: 'text'
  },
  {
    data: 'phone_number_two_name',
    type: 'text'
  },
  {
    data: 'private_lessons_offered',
    editor: 'select',
    selectOptions: ['Yes', 'No']
  },
  {
    data: 'notes',
    type: 'text'
  }
];

const colWidths = [1,200,100,150,150,150,150,150,150,150,150,100,100,400];

function correctBoolean(input, strToBool=false) {
  const buf = Object.assign({}, input);

  Object.keys(buf).forEach(key => {
    if (strToBool) {
      const idx = ["Yes", "No", "Y", "N", "True", "False", "T", "F"].indexOf(buf[key]);
      if (idx !== -1) {
        buf[key] = !(idx % 2);
      }
    } else if (typeof(buf[key]) === "boolean") {
      buf[key] = buf[key] ? "Yes" : "No";
    }
  });

  return buf;
}

function generateData(locations, changesArray) {
  const buffer = {};

  _.forEach(changesArray, item => {
    const { 0: index, 1: column, 2: wasValue, 3: value } = item;
    if (wasValue !== value) {
      const locationId = locations[index].id;
      if (!buffer[locationId]) { buffer[locationId] = {}; }

      buffer[locationId][column] = value;

      buffer[locationId] = correctBoolean(buffer[locationId], true);
    }
  });

  return buffer;
}

export {
  states,
  colHeaders,
  columns,
  colWidths,
  correctBoolean,
  generateData
};
